<template>
  <div class="container-withdraw-account" :class="[packageName]">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px; background-color: #f7f6f9;`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="goPrevious">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />
          <span class="tit-left">{{ $t('lang.wd.withdrawAccount') }}</span>
        </template>
      </van-nav-bar>
    </div>

    <div class="main">
      <!-- 图标 -->
      <div class="account-tit">
        <div class="account-img">
          <img :src="icon | imgPath" alt="" />
        </div>
        <span class="line"></span>
        <div class="account-name">{{ withdrawalMethod }}</div>
      </div>

      <!-- 提现名 -->
      <div class="select">
        <span>{{ $t('lang.wd.cc') }}</span>
        <div class="country">
          <img :src="locaFlag | imgPath" alt="" />
          <div class="account-name">{{ locaCode }}</div>
        </div>
      </div>

      <!-- 不是银行卡 -->

      <!-- 如果是沃达丰 或 Orange -->
      <div class="select" v-if="withdrawalMethod == 'Vodafone' || withdrawalMethod == 'Orange'">
        <span>{{ $t('lang.wd.accountNameAr') }}</span>
        <input style="color: #333" type="text" :placeholder="$t('lang.wd.accountNameArTip')" v-model.trim="accountName" />
      </div>
      <template v-else-if="withdrawalMethod == 'Paypal'">
        <div class="select">
          <span>{{ $t('lang.wd.name') }}</span>
          <input style="color: #333" type="text" :placeholder="$t('lang.common.yourRealName')" v-model.trim="accountName" />
        </div>
        <p class="paypal-tips">{{ $t('lang.common.realNameTips') }}</p>
      </template>
      <!-- 否则 -->
      <div class="select" v-else>
        <span>{{ $t('lang.wd.name') }}</span>
        <input style="color: #333" type="text" :placeholder="$t('lang.wd.phYourName')" v-model.trim="accountName" />
      </div>
      <div class="select">
        <span>{{ $t('lang.wd.phAccount') }}</span>
        <div class="select-account">
          <input type="text" maxlength="11" :placeholder="$t('lang.wd.accountNoArTip')" v-model="accountId" />
        </div>
      </div>

      <!-- 保存按钮 -->
      <div class="save-btn" :class="{ 'save-btn-act': this.saveFlag() }" @click="handleSave">
        {{ cfgId ? $t('lang.change') : $t('lang.wd.save') }}
      </div>
    </div>
  </div>
</template>

<script>
import { apiBindWithdrawAccount, apiEditWithdrawAccount } from '@/api/imee.js'

import _debounce from 'lodash/debounce'
import baseMixin from '../base.mixin.js'

export default {
  mixins: [baseMixin],
  data() {
    return {}
  },
  methods: {
    // 保存
    handleSave: _debounce(
      function () {
        // 去掉空格
        const strAccountId = `${this.accountId}`
        this.accountId = strAccountId.replace(/\s*/g, '')

        // 判断emoji表情
        if (this.hasEmojiCharacter(this.accountName)) {
          this.accountName = ''
          this.$client.showToast(this.$t('lang.wd.emojiTip'))
          return
        }

        const data = {
          accountId: this.accountId,
          accountName: this.accountName
        }

        // edit
        if (this.cfgId) {
          apiEditWithdrawAccount(data, this.cfgId).then((res) => {
            if (res.status === 200) {
              this.$client.showToast(res.message)
              const timer = setTimeout(() => {
                clearTimeout(timer)
                this.jumpWithdrawal()
              }, 500)
            }
          })
        }
        // add
        else {
          data.withdrawalMethod = this.withdrawalMethod
          apiBindWithdrawAccount(data).then((res) => {
            if (res.status === 200) {
              this.$client.showToast(res.message)
              const timer = setTimeout(() => {
                clearTimeout(timer)
                this.jumpWithdrawal()
              }, 500)
            }
          })
        }
      },
      3000,
      {
        leading: true,
        trailing: false
      }
    ),

    // 保存按钮的校验
    saveFlag() {
      if (this.accountId && this.accountName) {
        return true
      }

      return false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../base.scss';
</style>
